import { progressCellRenderer } from "./util";

export const leftColumn = [
  {
    field: "order_name",
    headerName: "주문명",
    flex: 1.5,
    sortable: true,
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
  },
  {
    field: "item_name",
    headerName: "아이템명",
    flex: 1,
    sortable: true,
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
  },
  {
    field: "qty",
    headerName: "수량",
    flex: 1,
    sortable: true,
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
  },
  {
    field: "progress_result",
    headerName: "진행률",
    flex: 2,
    headerClass: "grid-header",
    sortable: true,
    cellStyle: { textAlign: "center" },
    cellRenderer: progressCellRenderer,
    valueFormatter: (params) => {
      if (!params.value && params.value !== 0) return "";
      const value = parseFloat(params.value);
      return isNaN(value) ? params.value : `${value}`;
    },
    comparator: (valueA, valueB) => {
      const numA = parseFloat(valueA);
      const numB = parseFloat(valueB);
      if (isNaN(numA) && isNaN(numB)) return 0;
      if (isNaN(numA)) return -1;
      if (isNaN(numB)) return 1;
      return numA - numB;
    },
  },
  {
    field: "style_field",
    hide: true,
  },
];

export const rightColumn = [
  {
    field: "order_name",
    headerName: "주문명",
    flex: 1.5,
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
  },
  {
    field: "proc_name",
    headerName: "공정명",
    sortable: false,
    flex: 1.5,
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
  },
  {
    field: "qty",
    headerName: "전체수량",
    flex: 1.5,
    sortable: false,
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
  },
  {
    field: "completed_qty",
    headerName: "완료수량",
    sortable: false,
    flex: 1.5,
    cellEditor: "agTextCellEditor",
    cellStyle: { textAlign: "center" },
    editable: true,
    headerClass: "grid-header",
    cellRenderer: (params) => {
      if (params.value === null || params.value === undefined) {
        return "";
      }
      const completedQty = Number(params.value);
      const totalQty = params.data.qty === null ? 0 : Number(params.data.qty);
      const percentValue =
        totalQty > 0
          ? Math.max(0, Math.min(100, (completedQty / totalQty) * 100))
          : 0;
      const containerStyle = {
        width: "100%",
        height: "36px",
        position: "relative",
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        overflow: "hidden",
        margin: "5px 0",
        backgroundColor: "#f5f5f5",
      };
      let fillColor = "#a3f6ff";
      if (completedQty > totalQty) {
        fillColor = "#ff8787";
      } else {
        try {
          const currentOrderId = params.data.order_id;
          let allRowsData = [];
          params.api.forEachNode((node) => {
            if (node.data) {
              allRowsData.push(node.data);
            }
          });
          const rowsWithSameOrderId = allRowsData.filter(
            (row) => row.order_id === currentOrderId
          );
          rowsWithSameOrderId.sort(
            (a, b) => a.proc_sequence_no - b.proc_sequence_no
          );
          const currentRowIndex = rowsWithSameOrderId.findIndex(
            (row) => row.proc_id === params.data.proc_id
          );
          if (currentRowIndex > 0) {
            const previousRow = rowsWithSameOrderId[currentRowIndex - 1];
            const previousCompletedQty =
              previousRow.completed_qty === null
                ? 0
                : Number(previousRow.completed_qty);
            if (completedQty > previousCompletedQty) {
              fillColor = "#ff8787";
            }
          }
        } catch (error) {
          console.error("셀 스타일 계산 중 오류 발생:", error);
        }
      }
      const fillStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: `${percentValue}%`,
        backgroundColor: fillColor,
        transition: "width 0.5s ease-in-out",
      };
      const textStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "13px",
        fontWeight: "bold",
        color: "#333333",
        zIndex: 1,
      };
      return (
        <div
          style={containerStyle}
          onClick={(e) => {
            if (params.api && params.api.startEditingCell) {
              params.api.startEditingCell({
                rowIndex: params.node.rowIndex,
                colKey: params.column.colId,
              });
            }
            e.stopPropagation();
          }}
        >
          <div style={fillStyle}></div>
          <div style={textStyle}>{completedQty}</div>
        </div>
      );
    },
    cellStyle: { textAlign: "center" },
    cellEditorParams: {
      maxLength: 20,
    },
    valueParser: (params) => {
      const value = params.newValue;
      if (value === "" || (!isNaN(Number(value)) && value !== null)) {
        return value === "" ? null : Number(value);
      }
      return params.oldValue;
    },
  },
  {
    field: "style_field",
    hide: true,
  },
];

export const noRowsOverlayComponent = `
<div class="empty-grid-container">
<img src="/icons/table-rows-plus-2.png" alt="No Data" class="empty-icon" />
<h3 class="empty-title">표시할 데이터가 없습니다</h3>
<h4 class="empty-description">
  좌측의 주문 리스트를 클릭하여 입력할 실적을 추가하세요.
</h4>
</div>
`;
